export class BmsErrmeterTimestampfrom {
  meterid : number;
  status : number;
  status2 : number;
  timestampFrom : Date;
}
